import React, { useState, useEffect, useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './card.module.scss';
import {
  getCardType,
  getFormatedCVV,
  getFormatedExpirationDate,
  getFormatedNumber,
} from './utils/format';

const InputCard = props => {
  const {
    name,
    number,
    cvv,
    expirationDate,
    namePlaceholder,
    numberPlaceholder,
    isEditing,
  } = props;

  const [front, setFrontSide] = useState(false);
  const [typeCard, setCardType] = useState('');

  useEffect(
    () => {
      if (front && cvv !== '') {
        setFrontSide(false);
      }
    },
    [cvv],
  );

  useEffect(
    () => {
      if (!front) {
        setFrontSide(true);
      }
    },
    [name, number, expirationDate],
  );

  useEffect(
    () => {
      const type = number.length === 0 ? 'EMPTY' : 'NOT_EMPTY';
      setCardType(type);
    },
    [number],
  );

  const formatedNumber = useMemo(
    () => getFormatedNumber(number, numberPlaceholder),
    [number, numberPlaceholder],
  );
  const formatedCVV = useMemo(() => getFormatedCVV(cvv), [cvv]);
  const formatedEDate = useMemo(
    () => getFormatedExpirationDate(expirationDate),
    [expirationDate],
  );
  const renderFront = () => {
    const vName = name !== '' ? name : namePlaceholder;
    return (
      <Fragment>
        <span className={styles.valueNumber}>{formatedNumber}</span>
        <span className={styles.valueName}>{!isEditing ? vName : ''}</span>
        <span className={styles.valueDate}>
          {!isEditing ? formatedEDate : ''}
        </span>
      </Fragment>
    );
  };

  const renderBack = () => (
    <Fragment>
      <div className={styles.magneticLine} />
      <div className={styles.cvvInput}>
        <div>{formatedCVV}</div>
      </div>
    </Fragment>
  );

  return (
    <div
      className={`${styles[typeCard]}
      ${styles.InputCard} ${!front ? styles[`${typeCard}__isFlipped`] : ''}`}
    >
      <div className={`${styles.front} ${!front ? styles.noDisplay : ''}`}>
        {renderFront()}
      </div>
      <div className={`${styles.back}  ${front ? styles.noDisplay : ''}`}>
        {renderBack()}
      </div>
    </div>
  );
};

InputCard.propTypes = {
  name: PropTypes.string,
  number: PropTypes.string,
  cvv: PropTypes.string,
  expirationDate: PropTypes.string,
  namePlaceholder: PropTypes.string,
  numberPlaceholder: PropTypes.string,
};

InputCard.defaultProps = {
  name: '',
  number: '',
  cvv: '123',
  expirationDate: '',
  namePlaceholder: '',
  numberPlaceholder: '',
};

export default InputCard;
